/**
 * Optional per-line gift messages for Potions House.
 * The message is stored as a Shopify line-item property and follows that item into the order.
 */
document.addEventListener('click', async (event) => {
  const button = event.target instanceof Element ? event.target.closest('[data-gift-message-save]') : null;
  if (!(button instanceof HTMLButtonElement)) return;

  const container = button.closest('[data-gift-message]');
  if (!(container instanceof HTMLElement)) return;

  const input = container.querySelector('[data-gift-message-input]');
  const status = container.querySelector('[data-gift-message-status]');
  const lineKey = container.dataset.lineKey;
  if (!(input instanceof HTMLTextAreaElement) || !(status instanceof HTMLElement) || !lineKey) return;

  button.disabled = true;
  status.textContent = 'Saving your message…';

  try {
    const parsedProperties = JSON.parse(container.dataset.properties || '{}');
    const properties = parsedProperties && typeof parsedProperties === 'object' && !Array.isArray(parsedProperties)
      ? { ...parsedProperties }
      : {};
    const message = input.value.trim();

    if (message) {
      properties['Gift message'] = message;
    } else {
      delete properties['Gift message'];
    }

    const root = window.Shopify?.routes?.root || '/';
    const response = await fetch(root + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ id: lineKey, properties }),
    });
    const result = await response.json();

    if (!response.ok || result.status) {
      throw new Error(result.description || result.message || 'The message could not be saved.');
    }

    status.textContent = 'Message saved.';
    window.location.reload();
  } catch (error) {
    status.textContent = error instanceof Error
      ? error.message
      : 'The message could not be saved. Please try again.';
    button.disabled = false;
  }
});
